var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 311.12,
    height: 48,
    viewBox: "0 0 311.12 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 88336",
    d: "M244.864 1.491V47.1h-6.931v-4.807h-.126a10.911 10.911 0 0 1-9.866 5.495c-7.306 0-13.053-6.182-13.053-15.549C214.826 22.06 221.2 16 228.5 16c4.182 0 7.183 1.685 8.553 3.933h.126V0l7.679 1.491zm-7.679 27.875a11.638 11.638 0 0 0-.185-2.061 6.736 6.736 0 0 0-6.618-5.371c-4.933 0-7.681 4.371-7.681 9.992s2.749 9.677 7.618 9.677a6.779 6.779 0 0 0 6.621-5.432 8.583 8.583 0 0 0 .249-2.247v-4.56z",
    transform: "translate(-158.475)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 88337",
    d: "M374.58 92.059h-6.994v-3.371h-.186a11.109 11.109 0 0 1-8.991 4.059c-6.119 0-9.556-4.434-9.556-9.054 0-7.618 6.807-11.554 18.046-11.491v-.5c0-2-.811-5.308-6.18-5.308a16.128 16.128 0 0 0-8.183 2.247l-1.5-5a21.913 21.913 0 0 1 10.992-2.686c9.742 0 12.551 6.182 12.551 12.864v18.24zM367.088 77.2c-5.434-.063-10.616 1.061-10.616 5.684a4.03 4.03 0 0 0 4.371 4.371 6.3 6.3 0 0 0 6.057-4.185 5.147 5.147 0 0 0 .189-1.685V77.2z",
    transform: "translate(-257.268 -44.957)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 88338",
    d: "m474.27 0 7.679 1.494V47.1h-7.679z",
    transform: "translate(-349.763)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 88339",
    d: "M538.839 19.475a4.106 4.106 0 0 1-4.371 4.122 4 4 0 0 1-4.248-4.122 4.313 4.313 0 0 1 8.621 0m-8.183 8.493h7.681v30.41h-7.681z",
    transform: "translate(-391.024 -11.276)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 88340",
    d: "m588.261 63.58 3.121 13.8a175.195 175.195 0 0 1 2 9.866h.123c.625-3.308 1.622-6.681 2.436-9.8l4-13.861h6.245l3.809 13.488c.937 3.557 1.748 6.87 2.434 10.178h.126c.436-3.308 1.187-6.621 2-10.178l3.371-13.488h7.556l-9.562 30.408h-7.12l-3.623-12.362a93.842 93.842 0 0 1-2.31-9.742h-.123a93.346 93.346 0 0 1-2.313 9.742l-3.87 12.362h-7.183l-8.988-30.41h7.865z",
    transform: "translate(-428.024 -46.889)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 88341",
    d: "M792.739 76.58c0 11.176-7.868 16.174-15.612 16.174-8.556 0-15.237-5.87-15.237-15.673s6.558-16.111 15.738-16.111 15.114 6.369 15.114 15.612m-22.921.312c0 5.87 2.938 10.3 7.555 10.3 4.374 0 7.432-4.245 7.432-10.427 0-4.744-2.121-10.241-7.369-10.241s-7.618 5.308-7.618 10.367",
    transform: "translate(-561.875 -44.964)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 88342",
    d: "M903.472 61.655h5.742V67.4h.189a9.093 9.093 0 0 1 8.367-6.432 8.155 8.155 0 0 1 1.811.186v7.18a12.5 12.5 0 0 0-2.313-.186 6.762 6.762 0 0 0-6.868 5.807 13.485 13.485 0 0 0-.189 2.31v15.8h-6.741v-30.41z",
    transform: "translate(-666.287 -44.964)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 88343",
    d: "m992.77 28.775 9.928-11.583h9.244l-11.3 12.428L1013.5 47.6h-9.427l-8.745-13.425-2.559 3.061V47.6h-6.76V.68l6.76 1.378z",
    transform: "translate(-727.159 -.502)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 88344",
    d: "M1104.375 84.939a16.628 16.628 0 0 0 7.742 2.25c3.371 0 4.87-1.436 4.87-3.434s-1.247-3.061-5-4.434c-5.933-2-8.367-5.245-8.367-8.868 0-5.369 4.434-9.493 11.488-9.493a17.534 17.534 0 0 1 8.117 1.811l-1.559 5.371a13.462 13.462 0 0 0-6.434-1.748c-2.685 0-4.245 1.373-4.245 3.247s1.436 2.809 5.308 4.245c5.558 1.935 8.057 4.746 8.117 9.241 0 5.558-4.308 9.553-12.362 9.553a19.625 19.625 0 0 1-9.243-2.124l1.562-5.621z",
    transform: "translate(-813.296 -44.957)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 88345",
    d: "M44.458 40.788c-2.7-7.453-3.665-20.212-3.667-20.288C39.9 7.891 31.666.026 20.385 0A20.293 20.293 0 0 0 0 20.385C.029 31.665 7.894 39.9 20.5 40.788c.079.005 12.837.971 20.288 3.67A60.148 60.148 0 0 1 48 48a59.827 59.827 0 0 1-3.541-7.212",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.3d111b0d6cf8ff2cb10d453b099d1327.svg";
export { ForwardRef as ReactComponent };